/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Close_Time_StretchInputs */

const en_close_time_stretch = /** @type {(inputs: Close_Time_StretchInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Close Time Stretch`)
};

const fr_close_time_stretch = /** @type {(inputs: Close_Time_StretchInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Fermer étirement du timecode`)
};

const de_close_time_stretch = /** @type {(inputs: Close_Time_StretchInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Zeitdehnung`)
};

const it_close_time_stretch = /** @type {(inputs: Close_Time_StretchInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Chiudi Time Stretch`)
};

const ru_close_time_stretch = /** @type {(inputs: Close_Time_StretchInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Затяжка короткого промежутка времени`)
};

const es_close_time_stretch = /** @type {(inputs: Close_Time_StretchInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Estiramiento de tiempo de cierre`)
};

const zh_cn2_close_time_stretch = /** @type {(inputs: Close_Time_StretchInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`接近时间拉伸`)
};

const ja_close_time_stretch = /** @type {(inputs: Close_Time_StretchInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`タイムストレッチを閉じる`)
};

const hi_close_time_stretch = /** @type {(inputs: Close_Time_StretchInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`समय अंतराल समाप्त`)
};

const pt_pt2_close_time_stretch = /** @type {(inputs: Close_Time_StretchInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Fechar Tempo Esticar`)
};

/**
* | output |
* | --- |
* | "Close Time Stretch" |
*
* @param {Close_Time_StretchInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const close_time_stretch = /** @type {((inputs?: Close_Time_StretchInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Close_Time_StretchInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return fr_close_time_stretch(inputs)
	if (locale === "de") return de_close_time_stretch(inputs)
	if (locale === "it") return it_close_time_stretch(inputs)
	if (locale === "ru") return ru_close_time_stretch(inputs)
	if (locale === "es") return es_close_time_stretch(inputs)
	if (locale === "zh-CN") return zh_cn2_close_time_stretch(inputs)
	if (locale === "ja") return ja_close_time_stretch(inputs)
	if (locale === "hi") return hi_close_time_stretch(inputs)
	if (locale === "pt-PT") return pt_pt2_close_time_stretch(inputs)
	return en_close_time_stretch(inputs)
});